/*jshint esversion: 9 */
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { doLog } from '../../shared/utility';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
};

export const authSuccess = (token, userId, userName, modulePermissions) => {
    // if (doLog()) console.log('[auth.authSuccess] modulePermissions:',modulePermissions);
    // if (doLog()) console.log('[auth.authSuccess] deep copy modulePermissions:',deepCopy(modulePermissions));
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        userId: userId,
        userName: userName,
        modulePermissions: modulePermissions
    }
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
};

export const logout = () => {
    if (doLog()) console.log('auth_actions.logout');
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('localId');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

export const checkAuthTimeout = (expirationTime) => {
    if (doLog()) console.log('auth_actions.checkAuthTimeout expirationTime:' + expirationTime);
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

export const auth = (user, password) => {
    return dispatch => {
        dispatch(authStart());
        let authData = {
            user: user,
            password: password,
            returnSecureToken: true
        };
        let url = null;

        authData = {
            userCode: user,
            password: password
        }
        url = 'auth/login';

        // if (doLog()) console.log('auth_actions.auth authData:', authData);

        axios.post(url, authData)
           .then(response => {
                // if (doLog()) console.log(response);
                let responseData = response.data;
                //if (doLog()) console.log('responseData:',responseData);
                if (typeof responseData === 'string' && ! responseData.startsWith('{')) {
                    let pos = responseData.indexOf('{');
                    if ( pos !== -1 ) {
                        responseData = JSON.parse(responseData.substring(pos));
                        //if (doLog()) console.log('new responseData:',responseData);
                    }
                }
                if (doLog()) console.log('auth_actions.auth responseData:',responseData);
                let message = '';
                if ( response === '' ) {
                    dispatch(authFail("Error sending request"));
                }
                else if ( responseData.status === 'Failure' ) {
                    message = responseData.result;
                    if (doLog()) console.log('auth_actions.auth message:',message);
                    dispatch(authFail(message));
                }
                else {
                    const expirationDate = new Date(new Date().getTime() + (responseData.timeout * 1000));
                    localStorage.setItem('token', responseData.token);
                    localStorage.setItem('expirationDate', expirationDate);
                    // localStorage.setItem('localId', responseData.userId);
                    localStorage.setItem('localId', '');
                    let modulePermissions = {
                        allowManageDB: responseData.allowManageDB,
                        allowReports: responseData.allowReports,
                        allowReview: responseData.allowReview,
                        allowedAgencyCode: responseData.allowedAgencyCode,
                        allowTIMS: responseData.allowTIMS,
                    };
                
                    dispatch(authSuccess(responseData.token, responseData.userId, responseData.userName, modulePermissions));
                    dispatch(checkAuthTimeout(responseData.timeout));
                }    
           })
           .catch(err => {
                if (doLog()) console.log('auth_actions.auth  err:', err);
                // if (typeof err === 'string')
                    dispatch(authFail(err));
                // else
                    // dispatch(authFail(err.response.data.error));
           });
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        }
        else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate > new Date()) {
                const localId = localStorage.getItem('localId');
                dispatch(authSuccess(token, localId));
                //Calculate the next timeout time in seconds
                dispatch(checkAuthTimeout( (expirationDate.getTime() - new Date().getTime()) / 1000 ) );
            } else {
                dispatch(logout());
            }
        }
    };
};